"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiSelectOptionsSchema = void 0;
exports.default = MultiSelectFields;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_hook_form_1 = require("react-hook-form");
const material_1 = require("@mui/material");
const zod_1 = require("zod");
exports.multiSelectOptionsSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            // @ts-ignore
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.string().array().min(1, 'Required'),
    max: (maxSelected) => zod_1.z.string().array().max(maxSelected, `Max ${maxSelected} selections allowed`),
});
function MultiSelectFields({ name, groupLabel, required = true, formHelperText, multiSelectOptions, allowNone = true, }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const labelId = (0, react_1.useId)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const fieldValues = (0, react_hook_form_1.useWatch)({ control, name });
    const handleChange = (value) => {
        let newFieldValues = [...fieldValues];
        if (newFieldValues.length < 1) {
            newFieldValues.push(value);
        }
        else if (!newFieldValues.includes(value)) {
            if (isNone(value)) {
                newFieldValues = [value];
            }
            else {
                newFieldValues.push(value);
                newFieldValues = newFieldValues.filter((element) => !isNone(element));
            }
        }
        else {
            newFieldValues.splice(newFieldValues.indexOf(value), 1);
        }
        field.onChange(newFieldValues);
    };
    const error = errors[name];
    const isNone = (val) => val === 'none';
    const getColumns = (size, optionsCount) => {
        if (size === 'sm') {
            return optionsCount >= 10 ? 6 : 12;
        }
        else if (size === 'md') {
            if (optionsCount > 10) {
                return 4;
            }
            else if (optionsCount <= 10 && optionsCount > 5) {
                return 6;
            }
            else {
                return 12;
            }
        }
    };
    if (allowNone && !isNone(multiSelectOptions[0].value)) {
        multiSelectOptions.unshift({
            label: 'None',
            value: 'none',
        });
    }
    return ((0, jsx_runtime_1.jsxs)(material_1.FormControl, { fullWidth: true, error: Boolean(error), required: required, component: "fieldset", children: [(0, jsx_runtime_1.jsx)(material_1.FormLabel, { id: labelId, component: "legend", children: (0, jsx_runtime_1.jsx)(material_1.Typography, { variant: "bodyMediumBook", children: groupLabel }) }), (0, jsx_runtime_1.jsx)(material_1.FormGroup, { children: (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, children: (0, jsx_runtime_1.jsx)(material_1.Grid, { container: true, columns: 12, children: multiSelectOptions.map((option) => ((0, jsx_runtime_1.jsxs)(material_1.Grid, { item: true, xs: 12, sm: isNone(option.value) ? 12 : getColumns('sm', multiSelectOptions.length), md: isNone(option.value) ? 12 : getColumns('md', multiSelectOptions.length), children: [(0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { onChange: () => {
                                            handleChange(option.value);
                                        }, checked: Array.isArray(field.value) &&
                                            field.value.some((checked) => checked === option.value), name: option.label, color: "secondary" }), label: option.label, componentsProps: {
                                        typography: {
                                            variant: 'bodyMediumBook',
                                            color: 'text.secondary',
                                        },
                                    } }), option.extendedOptions ? option.extendedOptions : null] }, option.value))) }) }) }), (0, jsx_runtime_1.jsx)(material_1.FormHelperText, { children: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: typeof error !== 'boolean' && (error === null || error === void 0 ? void 0 : error.message) ? error.message : formHelperText }) })] }));
}
//# sourceMappingURL=MultiSelectFields.js.map